import BoxTitle from "@/routes/org/_components/box-title"
import { langStore } from "@/stores/lang-store"
import Wrapper from "@/components/wrapper"
import { overviewBundle } from "./overview-const"

const Overview = ({ overview }) => {
  const lang = langStore((s) => s.lang)

  return (
    <Wrapper.shadow>
      <BoxTitle title={overviewBundle.title[lang]} />
      <article className="min-w-70 px-3 py-2">
        {overviewBundle.labels.map((item) => {
          return (
            <div
              key={item.key}
              className="flex justify-between text-[#555] py-2 border-b border-b-gray-100"
            >
              <span className="font-medium">{item.label[lang]}</span>
              <span className="text-[#1dd3b0] font-semibold">
                {overview?.[item.key]?.toLocaleString() ?? "-"} {item.unit[lang]}
              </span>
            </div>
          )
        })}
      </article>
    </Wrapper.shadow>
  )
}

export default Overview
